import { useEffect } from 'react'
import { AvoidSoftInput } from 'react-native-avoid-softinput'

//export { AvoidSoftInputView }

export function useAvoidSoftInputForModal(visible: boolean) {
    useEffect(() => {
        AvoidSoftInput.setEnabled(visible)

        return () => AvoidSoftInput.setEnabled(false)
    }, [visible])
}
